import React, { useState, useEffect } from "react";
import styles from "./ShareHolders.module.scss";
import shareholderBanner from "../../assets/images/shareholderBanner.png";
import IepfIcon from "../../assets/images/IepfIcon.png";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import {
  AccordionContent,
  AccordionHeader,
  ContactSection,
} from "./Investor.tsx";
import { Icon } from "../../assets/Icons.tsx";
import ImageTextSection from "../CustomComponent/ImageTextSection.tsx";
import { motion } from "framer-motion";


import {
  investorShareholderKYCData,
  investorShareholderIEPFData,
  investorShareholderIEPF_2_Data,
  investorShareholderIEPF_7_Data,
  investorShareholderIEPF_4_Data,
} from "../../redux/slices/investorSlice.js";
import { useDispatch } from "react-redux";

const ShareHolders: React.FC = () => {
  const dispatch = useDispatch();

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const [kYCData, setKYCData] = useState(null);
  const [iEPFData, setIEPFData] = useState(null);

  const [iEPF_2_Data, setIEPF_2_Data] = useState(null);
  const [iEPF_7_Data, setIEPF_7_Data] = useState(null);
  const [iEPF_4_Data, setIEPF_4_Data] = useState(null);
  const [loadingKYC, setLoadingKYC] = useState(true);
  const [loadingIEPF, setLoadingIEPF] = useState(true);
  const [loadingIEPF2, setLoadingIEPF2] = useState(true);
  const [loadingIEPF7, setLoadingIEPF7] = useState(true);
  const [loadingIEPF4, setLoadingIEPF4] = useState(true);

  const startYear = 2014;

  const endYear = new Date().getFullYear();
  const years = [];

  for (let year = endYear - 1; year >= startYear; year--) {
    years.push(`${year}-${year + 1}`);
  }
  const [selectedYearIEPF, setSelectedYearIEPF] = useState(years[0]);

  const [selectedYearIEPF2, setSelectedYearIEPF2] = useState(years[0]);
  const [selectedYearIEPF7, setSelectedYearIEPF7] = useState(years[0]);
  const [selectedYearIEPF4, setSelectedYearIEPF4] = useState(years[0]);

  const handleIEPF2YearChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedYearIEPF2(event.target.value);
  };
  const handleIEPF7YearChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedYearIEPF7(event.target.value);
  };
  const handleIEPFYearChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedYearIEPF(event.target.value);
  };
  const handleIEPF4YearChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedYearIEPF4(event.target.value);
  };

  const handleToggleVisibility = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Investors", link: "/investors" },
    { title: "Shareholders", link: "" },
  ];
  const content = [
    `Aptech is dedicated to maintaining transparency and fostering trust with its valued shareholders.  `,
  ];
  const downloadFile = async (fileUrl, fileName) => {
    const url = fileUrl;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  useEffect(() => {
    const fetchShareholderKYCData = async () => {
      setLoadingKYC(true);
      try {
        const data = await dispatch(investorShareholderKYCData()).unwrap();
        setKYCData(data?.kyc_results?.[0]?.files || []);
        setLoadingKYC(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoadingKYC(false);
      }
    };
    fetchShareholderKYCData();
  }, [dispatch]);

  useEffect(() => {
    const fetchShareholderIEPFData = async () => {
      setLoadingIEPF(true);
      try {
        const data = await dispatch(
          investorShareholderIEPFData(selectedYearIEPF)
        ).unwrap();

        console.log(data, "datadata");
        setIEPFData(data?.iepf_results?.[0]?.files);
        setLoadingIEPF(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoadingIEPF(false);
      }
    };
    fetchShareholderIEPFData();
  }, [dispatch, selectedYearIEPF]);

  useEffect(() => {
    const fetchShareholderIEPF_2_Data = async () => {
      setLoadingIEPF2(true);
      try {
        const data = await dispatch(
          investorShareholderIEPF_2_Data(selectedYearIEPF2)
        ).unwrap();
        setIEPF_2_Data(data?.iepf_results?.[0]?.files);
        setLoadingIEPF2(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoadingIEPF2(false);
      }
    };
    fetchShareholderIEPF_2_Data();
  }, [dispatch, selectedYearIEPF2]);

  useEffect(() => {
    const fetchShareholderIEPF_7_Data = async () => {
      setLoadingIEPF7(true);
      try {
        const data = await dispatch(
          investorShareholderIEPF_7_Data(selectedYearIEPF7)
        ).unwrap();
        setIEPF_7_Data(data?.iepf_results?.[0]?.files);
        setLoadingIEPF7(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoadingIEPF7(false);
      }
    };
    fetchShareholderIEPF_7_Data();
  }, [dispatch, selectedYearIEPF7]);
  useEffect(() => {
    const fetchShareholderIEPF_4_Data = async () => {
      setLoadingIEPF4(true);
      try {
        const data = await dispatch(
          investorShareholderIEPF_4_Data(selectedYearIEPF4)
        ).unwrap();
        setIEPF_4_Data(data?.iepf_results?.[0]?.files);
        setLoadingIEPF4(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoadingIEPF4(false);
      }
    };
    fetchShareholderIEPF_4_Data();
  }, [dispatch, selectedYearIEPF4]);
  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className={styles.ShareHolders}>
        <div className="container">
          <div className="mb-5">
          <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
            <div className="row mt-5">
              <div className="col-12">
                <ImageTextSection
                  imageSrc={shareholderBanner}
                  imageAlt="shareholderBannerImage"
                  content={content}
                  reverse={true}
                  heading="Shareholders"
                  imageHeight={"25rem"}
                  imageHeightTablet={`25rem`}
                />
              </div>
            </div>
            </motion.div>
          </div>
          <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
          <div className="section">
            <ContactSection />
          </div>
          </motion.div>
          <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
          <div className="section">
            <p className="heading">Updation of KYC Details</p>
            <p className="para pt-3 mb-0">SEBI has, vide the Circular No.</p>
            <p className="para">
              SEBI/HO/MIRSD/MIRSD_RTAMB/P/CIR/2021/655 dated November 3, 2021,
              mandated the furnishing of PAN, Address with PIN, email address,
              mobile number, bank account details and nomination by holders of
              physical securities.
            </p>
            <p className="para">
              Folios wherein any one of the cited document / details are not
              available on or after April 01, 2023, shall be frozen by the
              Registrars and Transfer Agent of the Company (RTA). 
            </p>
            <p className="para">
              The Shareholders of the Company holding equity shares in physical
              mode are requested to go through the SEBI Circulars and do the
              needful. 
            </p>

            {!loadingKYC ? (
              <div className="row d-flex justify-content-center">
                {kYCData?.map((item, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6 mb-4" key={index}>
                    <div className={`${styles.pdfCard}`}>
                      {item?.document_type === "pdf" && (
                        <div className={`d-flex align-items-center`}>
                          <Icon name="pdfIcon" width="30px" height="30px" />
                          <p className={`para mb-0 ${styles.textStyle}`}>
                            <strong>{item.title}</strong>
                          </p>
                        </div>
                      )}
                      <div className={styles.icons}>
                        <span>
                          <a
                            href={item?.document_path}
                            style={{
                              color: "#DB6516",
                              textDecoration: "none",
                            }}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Icon name="eyeIcon" color="#036995" />
                          </a>
                        </span>

                        {item.is_download && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item?.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" color="#036995" />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="para text-center pt-5">Loading...</p>
            )}
          </div>
          </motion.div>
          <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
          <div className="section">
            <p className="heading">IEPF</p>
            <p className="para pt-3">
              Any person, whose unclaimed or unpaid dividend amount has been
              transferred by the company to IEPF may claim their refunds to the
              IEPF authority. For claiming such amount, claimant needs to file
              form IEPF-5 along with requisite documents. Visit
              https://www.iepf.gov.in/IEPF/refund.html to access link to the
              refund webpage of IEPF Authority website. 
            </p>

            <div className="row mt-0 mb-5">
              <div className="col-12">
                <div className={styles.accordion}>
                  {/* Accordion Item 1 */}
                  <div className={styles.accordionItem}>
                    <AccordionHeader
                      activeIndex={activeIndex}
                      image={IepfIcon}
                      title="Unpaid & Unclaimed Dividend (Form IEPF-2)"
                      toggle={() => handleToggleVisibility(0)}
                      index={0}
                    />
                    <AccordionContent activeIndex={activeIndex} index={0}>
                      <div>
                        <div className={`row ${styles.divBorder}`}>
                          <div className="col-lg-8 col-md-12 col-sm-12 p-0">
                            {!loadingIEPF2 ? (
                              <>
                                {iEPF_2_Data?.length > 0 && (
                                  <>
                                    {iEPF_2_Data?.map((item, index) => (
                                      <div
                                        className="d-flex align-items-center pb-3"
                                        key={index}
                                      >
                                        {item?.document_type === "pdf" && (
                                          <Icon
                                            name="pdfIcon"
                                            height="30x"
                                            width="30px"
                                          />
                                        )}
                                        <div className="d-flex justify-content-center align-items-center">
                                          <p
                                            className={`para mb-0 blueText ${styles.contentText}`}
                                          >
                                            <a
                                              href={item?.document_path}
                                              style={{
                                                textDecoration: "none",
                                                color: "#DB6516",
                                              }}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {item.title}
                                            </a>
                                          </p>
                                          {item?.is_download && (
                                            <span
                                              className="d-flex justify-content-center align-items-center"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                downloadFile(
                                                  item?.document_path,
                                                  item.title
                                                )
                                              }
                                            >
                                              <Icon
                                                name="circleDownArrow"
                                                width="25px"
                                                height="25px"
                                              />
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                                 {!iEPF_2_Data?.length && (
                                  <p className={`para caps mb-0 pt-1 ${styles.messageStyle}`}><strong>No data available</strong></p>
                                )}
                              </>
                            ) : (
                              <p className={`para ${styles.messageStyle}`}> Loading...</p>
                            )}
                          </div>
                          <div className="col-lg-4 col-md-12 col-sm-12">
                            <div
                              className={`row ${styles.yearSelectionDiv} d-flex justify-content-end`}
                            >
                              <div className="col-lg-12 col-md-7 p-0">
                                <div
                                  className={`d-flex justify-content-evenly ${styles.colBorder}`}
                                >
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: "150%" }}
                                    >
                                      <Icon
                                        name="calender"
                                        color="var(--text)"
                                      />
                                    </span>
                                    <p
                                      className={`para mb-0 ${styles.textPadding}`}
                                    >
                                      Financial Year
                                    </p>
                                  </div>
                                  <div
                                    className="vertical-line"
                                    style={{
                                      width: "1px",
                                      backgroundColor: "black",
                                    }}
                                  ></div>

                                  <div className={styles.customSelect}>
                                    <select
                                      value={selectedYearIEPF2}
                                      onChange={handleIEPF2YearChange}
                                      className={`para mb-0 ${styles.textPadding}`}
                                      style={{ fontWeight: 700 }}
                                    >
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          FY {year}
                                        </option>
                                      ))}
                                    </select>
                                    <div className={styles.customIcon}>
                                      <Icon
                                        name="dropDownArrow"
                                        width="30px"
                                        height="50px"
                                        color="black"
                                        strokeWidth="2"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionContent>
                  </div>

                  {/* Accordion Item 2 */}
                  <div className={styles.accordionItem}>
                    <AccordionHeader
                      activeIndex={activeIndex}
                      image={IepfIcon}
                      title="Details of Shares liable to transfer to IEPF Suspense account"
                      toggle={() => handleToggleVisibility(1)}
                      index={1}
                    />
                    <AccordionContent activeIndex={activeIndex} index={1}>
                      <div>
                        <div className={`row ${styles.divBorder}`}>
                          <div className="col-lg-8 col-md-12 col-sm-12 p-0">
                            {!loadingIEPF ? (
                              <>
                                {iEPFData?.length > 0 && (
                                  <>
                                    {iEPFData?.map((item, index) => (
                                      <div
                                        className="d-flex align-items-center pb-3"
                                        key={index}
                                      >
                                        {item?.document_type === "pdf" && (
                                          <Icon
                                            name="pdfIcon"
                                            height="30x"
                                            width="30px"
                                          />
                                        )}
                                        <div className="d-flex justify-content-center align-items-center">
                                          <p
                                            className={`para mb-0 blueText ${styles.contentText}`}
                                          >
                                            <a
                                              href={item?.document_path}
                                              style={{
                                                textDecoration: "none",
                                                color: "#DB6516",
                                              }}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {item.title}
                                            </a>
                                          </p>
                                          {item?.is_download && (
                                            <span
                                              className="d-flex justify-content-center align-items-center"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                downloadFile(
                                                  item?.document_path,
                                                  item.title
                                                )
                                              }
                                            >
                                              <Icon
                                                name="circleDownArrow"
                                                width="25px"
                                                height="25px"
                                              />
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                                  {!iEPFData?.length && (
                                  <p className={`para caps mb-0 pt-1 ${styles.messageStyle}`}><strong>No data available</strong></p>
                                )}
                              </>
                            ) : (
                              <p className={`para ${styles.messageStyle}`}> Loading...</p>
                            )}
                          </div>
                          <div className="col-lg-4 col-md-12 col-sm-12">
                            <div
                              className={`row ${styles.yearSelectionDiv} d-flex justify-content-end`}
                            >
                              <div className="col-lg-12 col-md-7 p-0">
                                <div
                                  className={`d-flex justify-content-evenly ${styles.colBorder}`}
                                >
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: "150%" }}
                                    >
                                      <Icon
                                        name="calender"
                                        color="var(--text)"
                                      />
                                    </span>
                                    <p
                                      className={`para mb-0 ${styles.textPadding}`}
                                    >
                                      Financial Year
                                    </p>
                                  </div>
                                  <div
                                    className="vertical-line"
                                    style={{
                                      width: "1px",
                                      backgroundColor: "black",
                                    }}
                                  ></div>

                                  <div className={styles.customSelect}>
                                    <select
                                      value={selectedYearIEPF}
                                      onChange={handleIEPFYearChange}
                                      className={`para mb-0 ${styles.textPadding}`}
                                      style={{ fontWeight: 700 }}
                                    >
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          FY {year}
                                        </option>
                                      ))}
                                    </select>
                                    <div className={styles.customIcon}>
                                      <Icon
                                        name="dropDownArrow"
                                        width="30px"
                                        height="50px"
                                        color="black"
                                        strokeWidth="2"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionContent>
                  </div>

                  {/* Accordion Item 3 */}
                  <div className={styles.accordionItem}>
                    <AccordionHeader
                      activeIndex={activeIndex}
                      image={IepfIcon}
                      title="Form IEPF-7 – Sum of Dividend on shares transferred to IEPF"
                      toggle={() => handleToggleVisibility(2)}
                      index={2}
                    />
                    <AccordionContent activeIndex={activeIndex} index={2}>
                      <div>
                        <div className={`row ${styles.divBorder}`}>
                          <div className="col-lg-8 col-md-12 col-sm-12 p-0">
                            {!loadingIEPF7 ? (
                              <>
                                {iEPF_7_Data?.length > 0 && (
                                  <>
                                    {iEPF_7_Data?.map((item, index) => (
                                      <div
                                        className="d-flex align-items-center pb-3"
                                        key={index}
                                      >
                                        {item?.document_type === "pdf" && (
                                          <Icon
                                            name="pdfIcon"
                                            height="30x"
                                            width="30px"
                                          />
                                        )}
                                        <div className="d-flex justify-content-center align-items-center">
                                          <p
                                            className={`para mb-0 blueText ${styles.contentText}`}
                                          >
                                            <a
                                              href={item?.document_path}
                                              style={{
                                                textDecoration: "none",
                                                color: "#DB6516",
                                              }}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {item.title}
                                            </a>
                                          </p>
                                          {item?.is_download && (
                                            <span
                                              className="d-flex justify-content-center align-items-center"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                downloadFile(
                                                  item?.document_path,
                                                  item.title
                                                )
                                              }
                                            >
                                              <Icon
                                                name="circleDownArrow"
                                                width="25px"
                                                height="25px"
                                              />
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                                 {!iEPF_7_Data?.length && (
                                  <p className={`para caps mb-0 pt-1 ${styles.messageStyle}`}><strong>No data available</strong></p>
                                )}
                              </>
                            ) : (
                              <p className={`para ${styles.messageStyle}`}> Loading...</p>
                            )}
                          </div>
                          <div className="col-lg-4 col-md-12 col-sm-12">
                            <div
                              className={`row ${styles.yearSelectionDiv} d-flex justify-content-end`}
                            >
                              <div className="col-lg-12 col-md-7 p-0">
                                <div
                                  className={`d-flex justify-content-evenly ${styles.colBorder}`}
                                >
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: "150%" }}
                                    >
                                      <Icon
                                        name="calender"
                                        color="var(--text)"
                                      />
                                    </span>
                                    <p
                                      className={`para mb-0 ${styles.textPadding}`}
                                    >
                                      Financial Year
                                    </p>
                                  </div>
                                  <div
                                    className="vertical-line"
                                    style={{
                                      width: "1px",
                                      backgroundColor: "black",
                                    }}
                                  ></div>

                                  <div className={styles.customSelect}>
                                    <select
                                      value={selectedYearIEPF7}
                                      onChange={handleIEPF7YearChange}
                                      className={`para mb-0 ${styles.textPadding}`}
                                      style={{ fontWeight: 700 }}
                                    >
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          FY {year}
                                        </option>
                                      ))}
                                    </select>
                                    <div className={styles.customIcon}>
                                      <Icon
                                        name="dropDownArrow"
                                        width="30px"
                                        height="50px"
                                        color="black"
                                        strokeWidth="2"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionContent>
                  </div>

                  {/* Accordion Item 4 */}
                  <div className={styles.accordionItem}>
                    <AccordionHeader
                      activeIndex={activeIndex}
                      image={IepfIcon}
                      title="Form IEPF-4 – Shares Transferred to IEPF Authority"
                      toggle={() => handleToggleVisibility(3)}
                      index={3}
                    />
                    <AccordionContent activeIndex={activeIndex} index={3}>
                      <div>
                        <div className={`row ${styles.divBorder}`}>
                          <div className="col-lg-8 col-md-12 col-sm-12 p-0">
                            {!loadingIEPF4 ? (
                              <>
                                {iEPF_4_Data?.length > 0 && (
                                  <>
                                    {iEPF_4_Data?.map((item, index) => (
                                      <div
                                        className="d-flex align-items-center pb-3"
                                        key={index}
                                      >
                                        {item?.document_type === "pdf" && (
                                          <Icon
                                            name="pdfIcon"
                                            height="30x"
                                            width="30px"
                                          />
                                        )}
                                        <div className="d-flex justify-content-center align-items-center">
                                          <p
                                            className={`para mb-0 blueText ${styles.contentText}`}
                                          >
                                            <a
                                              href={item?.document_path}
                                              style={{
                                                textDecoration: "none",
                                                color: "#DB6516",
                                              }}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {item.title}
                                            </a>
                                          </p>
                                          {item?.is_download && (
                                            <span
                                              className="d-flex justify-content-center align-items-center"
                                              style={{
                                                marginLeft: "5px",
                                                cursor: "pointer",
                                              }}
                                              onClick={() =>
                                                downloadFile(
                                                  item?.document_path,
                                                  item.title
                                                )
                                              }
                                            >
                                              <Icon
                                                name="circleDownArrow"
                                                width="25px"
                                                height="25px"
                                              />
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    ))}
                                  </>
                                )}
                                {!iEPF_4_Data?.length && (
                                  <p className={`para caps mb-0 pt-1 ${styles.messageStyle}`}><strong>No data available</strong></p>
                                )}
                              </>
                            ) : (
                              <p className={`para ${styles.messageStyle}`}> Loading...</p>
                            )}
                          </div>
                          <div className="col-lg-4 col-md-12 col-sm-12">
                            <div
                              className={`row ${styles.yearSelectionDiv} d-flex justify-content-end`}
                            >
                              <div className="col-lg-12 col-md-7 p-0">
                                <div
                                  className={`d-flex justify-content-evenly ${styles.colBorder}`}
                                >
                                  <div className="d-flex align-items-center justify-content-center">
                                    <span
                                      className="d-flex justify-content-center"
                                      style={{ fontSize: "150%" }}
                                    >
                                      <Icon
                                        name="calender"
                                        color="var(--text)"
                                      />
                                    </span>
                                    <p
                                      className={`para mb-0 ${styles.textPadding}`}
                                    >
                                      Financial Year
                                    </p>
                                  </div>
                                  <div
                                    className="vertical-line"
                                    style={{
                                      width: "1px",
                                      backgroundColor: "black",
                                    }}
                                  ></div>

                                  <div className={styles.customSelect}>
                                    <select
                                      value={selectedYearIEPF4}
                                      onChange={handleIEPF4YearChange}
                                      className={`para mb-0 ${styles.textPadding}`}
                                      style={{ fontWeight: 700 }}
                                    >
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          FY {year}
                                        </option>
                                      ))}
                                    </select>
                                    <div className={styles.customIcon}>
                                      <Icon
                                        name="dropDownArrow"
                                        width="30px"
                                        height="50px"
                                        color="black"
                                        strokeWidth="2"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </AccordionContent>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default ShareHolders;
